import React from "react";
import {Card, Descriptions} from "antd";

const BALANCED_LABEL_STYLE = {width: "15%"};
const BALANCED_CONTENT_STYLE = {width: "35%"};

export const ApplicationInfoCard = ({title, items, column = 1, balanced = false}) => (
    <Card title={title} size="small" style={{height: "100%"}}>
        <Descriptions
            bordered
            size="small"
            column={column}
            labelStyle={balanced ? BALANCED_LABEL_STYLE : undefined}
            contentStyle={balanced ? BALANCED_CONTENT_STYLE : undefined}
        >
            {items.map(item => (
                <Descriptions.Item key={item.label} label={item.label} span={item.span}>
                    {item.value ?? "-"}
                </Descriptions.Item>
            ))}
        </Descriptions>
    </Card>
);
